<!--
  SceneCreationAlert.svelte

  Displays a success alert when a scene has been created,
  or a "Scene Created" chip when the scene is pending upload.
-->
<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Alert, Chip } from '@Shelly/shelly-design-system';

	export let sceneCreated: boolean;
	export let sceneId: string | undefined;
	export let sceneIds: string[] | undefined;
	export let onOpenScene: (sceneId: string | undefined) => void;

	$: ids = (sceneIds && sceneIds.length > 0 ? sceneIds : sceneId ? [sceneId] : []).filter(Boolean);
</script>

{#if sceneCreated && ids.length > 0}
	<div class="mt-xs scene-alerts">
		{#each ids as id, index}
			<Alert
				type="success"
				heading={ids.length === 1
					? 'Scene created successfully!'
					: `Scene ${index + 1} of ${ids.length} created`}
				isHeadingBold={true}
				cta={{
					title: $format('button_open_scene', { default: 'Open Scene' }),
					enableAlertClick: true,
				}}
				on:cta_click={() => onOpenScene(id)}
			/>
		{/each}
	</div>
{:else if sceneCreated}
	<!-- Scene created but not yet uploaded (no sceneId yet) -->
	<div class="message-badge mt-xs">
		<Chip variant="success" icon="fas fa-check-circle" aria-label="Scene Created">
			Scene Created
		</Chip>
	</div>
{/if}

<style>
	.message-badge,
	.scene-alerts {
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;
		gap: var(--spacing-xs);
	}
</style>
